/* Legacy code - ignore this errors */
/* eslint class-methods-use-this: 0 */
import React from "react";
import Flexbox from "flexbox-react";
import { Spinner, Tab, Tabs } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";

@inject("IntegrationStore", "ToastStore", "CurrentUserStore")
@observer
export default class IntegrationsTabs extends React.Component {
  renderRightLinks() {
    const { currentUser } = this.props.CurrentUserStore;  

    const allowedAccountIds = [
      "6804890a-3257-46ed-a84a-d6ac156b0573",
      "4bea15d2-6b6f-4d4a-9b88-51a92b89d940",
      "f67f4ae7-0d5a-459c-b75c-4de0b3a3570f"
    ];
    
    const isAccountOwner = currentUser?.isAccountOwner;
    const currentAccountId = currentUser?.accountId;
    
    const canSeeManageProfileField =
    isAccountOwner && allowedAccountIds.includes(currentAccountId);
  
    
    return (
      <Tabs
        id="accountSettingsIntegrationsTabnav"
        selectedTabId={this.props.IntegrationStore.activeTab}
        vertical={true}
        onChange={tab => this.props.IntegrationStore.setActiveTab(tab)}
      >
        <Tab id="webhooks" title={I18n.t("js.webhooks")} />
        <Tab id="slack-integration" title={I18n.t("js.slack_integration")} />
        <Tab id="bamboohr-integration" title={I18n.t("js.bamboo_hr_integration")} />
        <Tab id="azure-integration" title={I18n.t("js.azure_integration")} />
        {canSeeManageProfileField && <Tab id="manage-profile-field" title="Manage Profile Field" />}
        <Tabs.Expander />
      </Tabs>
    );
  }

  render() {
    const { currentUser } = this.props.CurrentUserStore;
    if (!currentUser) {
      return <Spinner />;
    }
    return this.renderRightLinks();
  }
}
